export default "__VITE_ASSET__f77a193a__"